import { render, staticRenderFns } from "./ItensPedido.vue?vue&type=template&id=86e0f478"
import script from "./ItensPedido.vue?vue&type=script&lang=js"
export * from "./ItensPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports